import { render, staticRenderFns } from "./order_detial.vue?vue&type=template&id=c7730bf4&scoped=true"
import script from "./order_detial.vue?vue&type=script&lang=js"
export * from "./order_detial.vue?vue&type=script&lang=js"
import style0 from "./order_detial.vue?vue&type=style&index=0&id=c7730bf4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7730bf4",
  null
  
)

export default component.exports